import { MultipleFilterModel } from "./MultipleFilterModel";

export class FilterChangedModel {
    public searchString: string;
    public sortOrderString: string;
    public simpleFilters : string[];
    public multipleFilters : MultipleFilterModel[];
}